/**
 * Список идентификаторов GRPC коллекций.
 */
export const COLLECTION_IDS = {
  dealersCountries: 'dealers_countries',
  dealersClusters: 'dealers_clusters',
  dealersCities: 'dealers_cities',
  dealersDealers: 'dealers_dealers',
  dealersDealership: 'dealers_dealerships',
  vehiclesVehicles: 'vehicles_vehicles',
  vehiclesBooking: 'vehicles_booking',
  specificationsValues: 'vehicles_specifications',
  specificationsGroups: 'vehicles_specifications_groups',
  vehiclesMarketingInfo: 'vehicles_marketing_info',
};
